const API_URLS = {
  baseUrl: '',
  getOfferDetails: 'https://api-mobile-ci-vfal.vodafone.com/auth/customerMarketingProductAPI/v1/customerMarketingProduct',
  activateOffer: 'https://api-mobile-ci-vfal.vodafone.com/auth/salesOrderAPI/v4/salesOrder',
}

const COMMON_HEADERS = {
  'Content-Type': 'application/json',
}

export { API_URLS, COMMON_HEADERS }
